/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "BatchState": {
                "values": {
                  "DEFAULT_BATCH_STATE_DO_NOT_USE": 0,
                  "OPEN_FOR_ADDITIONS": 1,
                  "CLOSED_FOR_ADDITIONS": 2,
                  "POSTPONING_REFUNDS": 3,
                  "FIDELIUS_LOOKUP": 4,
                  "CALC_GATEWAY_BATCH_ID": 5,
                  "SENDING_TO_GATEWAY": 6,
                  "PENDING_GATEWAY_RESPONSE": 7,
                  "SUCCESS_RESPONSE_RECEIVED": 8,
                  "SKIPPED_EMPTY_BATCH": 9,
                  "FAILURE_RETRYABLE_ERROR": 10,
                  "FAILURE_NONRETRYABLE_ERROR": 11,
                  "FAILURE_RESPONSE_RECEIVED": 12,
                  "MANUAL_SUCCESS": 13,
                  "MANUAL_FAILURE": 14,
                  "ITEMIZATION_DATA_FETCH": 15,
                  "PAUSED": 16
                }
              },
              "BatchDetails": {
                "fields": {
                  "shard": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "gatewayBatchId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "externalBatchId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "submissionDetail": {
                    "type": "squareup.esperanto.model.BatchDetails.BatchSubmissionDetails",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "batchSuccess": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "batchErrorCode": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "batchErrorMessage": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "batchState": {
                    "type": "squareup.esperanto.model.BatchState",
                    "id": 8,
                    "rule": "optional"
                  },
                  "paymentSuccess": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "paymentErrorCode": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "paymentErrorMessage": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BatchSubmissionDetails": {
                    "fields": {
                      "createdAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "submittedAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      },
                      "closedAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BatchState && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BatchDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BatchDetails?.nested?.BatchSubmissionDetails) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BatchState @ squareup/esperanto/model/batch.proto at 9:1
 */
export const BatchState = $root.lookupEnum('squareup.esperanto.model.BatchState').values;
/**
 * SOURCE BatchDetails @ squareup/esperanto/model/batch.proto at 69:1
 */
export const BatchDetails = $root.lookupType('squareup.esperanto.model.BatchDetails');
fixType(BatchDetails);
Builder.createAndAttachToType(BatchDetails);
/**
 * A batch can be submitted multiple times, if previous
 * attempts timed out or otherwise failed.
 *
 * SOURCE BatchSubmissionDetails @ squareup/esperanto/model/batch.proto at 89:3
 */
BatchDetails.BatchSubmissionDetails = $root.lookupType('squareup.esperanto.model.BatchDetails.BatchSubmissionDetails');
fixType(BatchDetails.BatchSubmissionDetails);
Builder.createAndAttachToType(BatchDetails.BatchSubmissionDetails);